import {useState, useEffect, createContext} from 'react';
//import {useCookies, Cookies} from "react-cookie"
import {Cookies, useCookies} from "react-cookie"
import {Routes, Route, Link} from "react-router-dom"

import {Header} from "./components/header/Header"
import {Home} from "./components/Home"
import {Compte} from "./components/compte/Compte"
import {CompteConfig} from "./components/compte/CompteConfig"
import {Admin} from "./components/compte/Admin"
import {Notions} from "./components/Notions"
import {Tuto} from "./components/Tuto"
import {Logout} from "./components/compte/Logout"
import {Convertisseur} from "./components/Convertisseur"
import './App.css';

export const UserContext = createContext('')
export const UpdateUserContext = createContext('')

function App() {

  const [menu, setMenu] = useState(['...', '...'])

  // =============== Authentification  ===============

  //const [cookies, setCookie, removeCookie] = useCookies()
  const [cookies, setCookie, removeCookie] = useCookies(['nom', 'prenom', 'classe'])
  const cook = new Cookies();

  const [currentUser, setCurrentUser] = useState({    
    nom:cook.get("nom"),
    prenom:cook.get("prenom"),
    mdp:cook.get("mdp"),
  })

  const auth = {    
    nom:cook.get("nom"),
    prenom:cook.get("prenom"),
    mdp:cook.get("mdp"),
  }

  const updateUsercontext = (param='') => {
    if(!auth.nom){return}
      
    fetch("https://maths-au-quotidien.fr/react-automaths/api.php", {
      method: 'POST',
      body: JSON.stringify({
        nom:cook.get("nom"),
        prenom:cook.get("prenom"),
        mdp:cook.get("mdp")
      })
    })
    .then(response => response.json())
    .then(data => {
      setCurrentUser(data)
      if(param && 'creer_groupe__suppr_groupe'.includes(param)){setMenu(['Gestion', 'Questions'].concat(data.liste_classes))}
    })
    .catch(err => console.log(err))
  }
  //==================================================

  const handleLogout = (e) => {
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() - 2);
    setCookie(['nom'], currentUser.nom, { path: '/', expires: expirationDate })
    setCookie(['prenom'], currentUser.prenom, { path: '/', expires: expirationDate })
    setCookie(['mdp'], currentUser.mdp, { path: '/', expires: expirationDate })
    /*removeCookie('nom');
    removeCookie('prenom');
    removeCookie('mdp');*/
    cook.remove("nom")
    cook.remove("prenom")
    cook.remove("mdp")
    setCurrentUser({})
    //setUser({})
 }

  /*useEffect(()=>{
    if(currentUser.nom) {
      updateUsercontext()
    }
  });*/

  return (
    <>
      <UserContext.Provider value={{currentUser, setCurrentUser}}>
      <UpdateUserContext.Provider value={updateUsercontext}>

      <Header handleLogout={handleLogout} />

      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/automaths" element={<Home/>}/>
        <Route path="/compte" element={<Compte menu={menu} setMenu={setMenu} />}/>
        <Route path="/compteConfig" element={<CompteConfig />}/>
        <Route path="/notions/:niveau" element={<Notions auth={{...auth, profil:currentUser.profil}}/>}/>
        <Route path="/tuto" element={<Tuto/>}/>
        <Route path="/logout" element={<Logout auth={auth} handleLogout={handleLogout} />}/>
        <Route path="/convertisseur" element={<Convertisseur />}/>
        <Route path="/admin" element={<Admin auth={{...auth, statut:currentUser.statut}}/>}/>
      </Routes>

      {/*<Link to="/" title="Automaths" className="btn"> - Automaths - </Link>*/}

      </UpdateUserContext.Provider>
      </UserContext.Provider>
    </>
  );
}

export default App;
